import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const GroupText = ({ label, text, icon, invert }) => {
  const ContentStyle = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: ${invert ? 'column-reverse' : 'column'};
    margin-bottom: 8px;
  `;

  const labelStyle = { fontWeight: 'bolder' };
  const textStyle = { fontSize: '13px', color: '#808080' };

  return (
    <ContentStyle>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          columnGap: '3px',
        }}
      >
        {icon}
        <span style={invert ? labelStyle : textStyle}>{text}</span>
      </div>
      <span style={invert ? textStyle : labelStyle}>{label}</span>
    </ContentStyle>
  );
};

GroupText.propTypes = {
  label: PropTypes.any.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  invert: PropTypes.bool,
};

export default GroupText;
